import { precoProdutoVigente, promocaoVigente } from './promocao';
const numero = (value: any) => {
  const text = String(value ?? '').trim();
  return text ? Number(text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text) : NaN;
};
export type OfertaProduto = { normal: number; atual: number; percentual: number; aPartirDe: boolean };
export function ofertaProduto(produto: any, data: Date | null = new Date()): OfertaProduto | null {
  const pizza = produto?.tipo === 'pizzas';
  const candidatos = pizza ? produto.valores || [] : [produto];
  // O preço anterior deve pertencer ao mesmo tamanho que gerou o menor preço atual.
  const candidato = candidatos.filter(Boolean).map((p: any) => ({ p, atual: numero(precoProdutoVigente(p, data)) }))
    .filter((p: any) => Number.isFinite(p.atual) && p.atual >= 0).sort((a: any, b: any) => a.atual - b.atual)[0];
  if (!candidato || !promocaoVigente(candidato.p.promocao, data)) return null;
  const normal = numero(candidato.p.valorNormalPromocao ?? candidato.p.valor);
  const atual = candidato.atual;
  if (!Number.isFinite(normal) || normal <= 0 || atual >= normal) return null;
  return { normal, atual, percentual: Math.min(atual === 0 ? 100 : 99, Math.round(((normal - atual) / normal) * 100)), aPartirDe: pizza };
}

// Na seleção de sabores, ambos os preços representam a mesma fração da pizza.
export function ofertaSaborPizza(valorTamanho: any, data: Date | null, sabores = 1): OfertaProduto | null {
  const oferta = ofertaProduto(valorTamanho, data);
  if (!oferta || !Number.isInteger(sabores) || sabores < 1) return null;
  return { ...oferta, normal: oferta.normal / sabores, atual: oferta.atual / sabores };
}
